import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { SkipLinkEnum } from '@shared/enum/skip-link.enum';
import VueSkipTo from '@components/vue-skip-to/VueSkipTo.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'SkipLinkComponent',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VueSkipTo, {
    "list-label": "Liens d'évitement",
    to: [
      { anchor: `#${_unref(SkipLinkEnum).NAVIGATION_MAIN}`, label: 'Aller au contenu' },
      { anchor: `#${_unref(SkipLinkEnum).NAVIGATION_MENU}`, label: 'Aller au menu' },
      {
        anchor: `#${_unref(SkipLinkEnum).NAVIGATION_FOOTER}`,
        label: 'Aller en bas de page',
      },
    ]
  }, null, 8 /* PROPS */, ["to"]))
}
}

})